export function shouldShowScheduleEditorUndoButton({ hasUndo, isLocked }) {
    return Boolean(hasUndo) && !isLocked
}
